import { render, staticRenderFns } from "./CategoryItemDetail.vue?vue&type=template&id=11b56e30&"
import script from "./CategoryItemDetail.vue?vue&type=script&lang=js&"
export * from "./CategoryItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports